import { render, staticRenderFns } from "./create-blends.vue?vue&type=template&id=3ebf9c3c&scoped=true"
import script from "./create-blends.vue?vue&type=script&lang=js"
export * from "./create-blends.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebf9c3c",
  null
  
)

export default component.exports